module.exports = __webpack_public_path__ + "79515ad0788973c533405f7012dfeccd.woff";